var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"img",staticClass:"shadow-sm lazy-image",class:_vm.wrapClass,attrs:{"src":_vm.shadowURL}})
}
var staticRenderFns = []

export { render, staticRenderFns }